import React from 'react'
import { useParams } from 'react-router-dom'
import useLoad from '../../eventsPublic/functions/useLoad'
import { loadJob, loadJobs } from '../../eventsPublic/apis/publicApi'
import { LABELS } from '../constants/staticText'
import JobsTable from './JobsTable'
import EventBreadcrumb from '../../eventsPublic/components/EventBreadcrumb'
import jobsTrail from '../functions/jobsTrail'
import JobDetailView from './JobDetailView'
import { useDocumentTitle } from '../../lib/a11y/useDocumentTitle'
import { useFocusHeading } from '../../lib/a11y/useFocusHeading'
import LoadingIndicator from '../../lib/components/LoadingIndicator'

const JobDetail = () => {
    const { slug } = useParams()
    const { data, loading, error } = useLoad(() => loadJob(slug), [slug])
    // Titel und Fokus nach dem Laden (#178): der Screenreader hoert, welche
    // Anzeige geoeffnet ist.
    useDocumentTitle(data ? `${data.title} – ${LABELS.pageTitle}` : LABELS.pageTitle)
    const headingRef = useFocusHeading(!loading && !!data)
    // Die weiteren Anzeigen kommen über die Firmen-ID des Public-Kontrakts
    // (company.id). Kein Ersatzwert: ein leerer Parameter würde den Server den
    // Filter überspringen lassen und fremde Anzeigen einblenden (#49).
    const firma = useLoad(
        () => (data ? loadJobs(`?company=${encodeURIComponent(data.company.id)}`) : Promise.resolve(null)),
        [data?.slug]
    )

    if (loading) return <LoadingIndicator label={LABELS.loadingJob} />
    if (error || !data) return <p className="jobs-state" role="status">{LABELS.error}</p>

    const weitere = (firma.data?.items || []).filter(j => j.slug !== data.slug)

    return (
        <>
            {/* Dieselbe Leiste wie in der Events-App, ueber dem Inhalt (#82);
                der Titel der Anzeige ist die letzte Station. */}
            <EventBreadcrumb trail={jobsTrail(data)} />
            <JobDetailView job={data} headingRef={headingRef}>
                {weitere.length > 0 && (
                    <section className="job-detail-more">
                        <h2>{LABELS.moreFrom} {data.company.name}:</h2>
                        <JobsTable jobs={weitere} />
                    </section>
                )}
            </JobDetailView>
        </>
    )
}

export default JobDetail
